import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getDocs, query, where, collection } from "firebase/firestore";
import { db } from "../firebase.js";
import "./menu_popup.css";
import Logo from '../assets/logo.png';
import { MdClose, MdOutlineMenu } from "react-icons/md";
export default function Menu_Popup({ isOpen, onClose }) {
    const panelRef = useRef(null);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("category");
    const [categoryData, setCategoryData] = useState([]);
    const [brandList, setBrandList] = useState([]);

    // ✅ Close on ESC key
    useEffect(() => {
        const onKey = (e) => e.key === "Escape" && onClose?.();
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [onClose]);

    // ✅ Close when clicked outside the panel
    useEffect(() => {
        const onDocClick = (e) => {
            if (isOpen && panelRef.current && !panelRef.current.contains(e.target)) {
                onClose?.();
            }
        };
        document.addEventListener("mousedown", onDocClick);
        return () => document.removeEventListener("mousedown", onDocClick);
    }, [isOpen, onClose]);

    // ✅ Fetch Categories
    useEffect(() => {
        const fetchCategories = async () => {
            setIsLoading(true);
            try {
                const q = query(collection(db, "products"), where("status", "==", true));
                const snapshot = await getDocs(q);

                if (snapshot.empty) {
                    setCategoryData([]);
                    return;
                }

                // Group by category
                const categoryMap = new Map();
                snapshot.docs.forEach((doc) => {
                    const data = doc.data();
                    if (data.category) {
                        categoryMap.set(data.category, {
                            category: data.category,
                            title: data.title || "",
                            price: data.price || "",
                            thumbnail: data.thumbnail || "",
                            uid: doc.id,
                        });
                    }
                });

                setCategoryData(Array.from(categoryMap.values()));
            } catch (err) {
                console.error("Error fetching categories:", err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchCategories();
    }, []);

    // ✅ Fetch Brand List
    useEffect(() => {
        const fetchBrands = async () => {
            setIsLoading(true);
            try {
                const q = query(collection(db, "products"), where("status", "==", true));
                const snapshot = await getDocs(q);

                if (snapshot.empty) {
                    setBrandList([]);
                    return;
                }

                const brandMap = new Map();

                for (const doc of snapshot.docs) {
                    const item = doc.data();
                    if (item.brandname && item.companyuid) {
                        const qb = query(
                            collection(db, "companies"),
                            where("uid", "==", item.companyuid)
                        );
                        const companySnap = await getDocs(qb);
                        let slug = "brand"; // fallback slug
                        let logo_url = "logo";
                        if (!companySnap.empty) {
                            slug = companySnap.docs[0].data().slug || "brand";
                        }
                        if (!companySnap.empty) {
                            logo_url = companySnap.docs[0].data().logo_url || "logo_url";
                        }



                        const brand = item.brandname.trim();
                        if (!brandMap.has(brand)) {
                            brandMap.set(brand, { name: brand, slug, logo_url, totalitems: 1 });
                        } else {
                            brandMap.get(brand).totalitems += 1;
                        }
                    }
                }

                setBrandList(Array.from(brandMap.values()));
            } catch (err) {
                console.error("Error fetching brands:", err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchBrands();
    }, []);

    return (
        <div className={`menu-popup-body ${isOpen ? "show" : ""}`}>
            {/* Overlay */}
            <div className="menu-overlay" onClick={onClose}></div>

            {/* Left Panel */}
            <div ref={panelRef} className={`menu-panel ${isOpen ? "slide-in" : "slide-out"}`}>
                <div className="menu-header">
                    <table  >
                        <tr>
                            <td width={25}>
                                <div onClick={onClose} className="button-menu cursor "><MdClose className="menu_icon" /></div>

                            </td>
                            <td>
                                <div className="logo-div"  >
                                    <img src={Logo} alt="Logo" className="brand-logo" />
                                    <div className='logo-name fcap'>Aooz<a className='logo-name-sub'></a>

                                    </div>

                                </div>
                            </td>
                        </tr>
                    </table>
                </div>

              
                    <div className="menu_list_div ">
                        <div className="ui-grid-fill">
                            {isLoading ? (
                                <div>Loading...</div>
                            ) : categoryData.length === 0 ? (
                                <div>No category found or checking connection...</div>
                            ) : (
                                categoryData.map((row, index) => (
                                    <div
                                        key={index}
                                        onClick={() => {
                                            navigate(`/filter?cat=${row.category}`);
                                            onClose();
                                        }}
                                        className="ui-items   cursor"
                                    >
                                        <div className="text-h2 sline fcap hover-u">
                                            {row.category}
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                

          
                {/* Footer Links */}
                <div  >
      <div
                        className="ui-items cursor b-top p-2"
                        onClick={() => {
                            navigate("/explore");
                            onClose();
                        }}
                    >
                        <div className="text-h2 sline fcap hover-u ">Explore</div>
                    </div>
                    <div
                        className="ui-items cursor b-top p-2"
                        onClick={() => {
                            navigate("/about");
                            onClose();
                        }}
                    >
                        <div className="text-h2 sline fcap hover-u ">About Us</div>
                    </div>

                    <div
                        className="ui-items cursor b-top p-2"
                        onClick={() => {
                            navigate("/support");
                            onClose();
                        }}
                    >
                        <div className="text-h2 sline fcap hover-u ">Support</div>
                    </div>
                    
                    <div
                        className="ui-items cursor b-top p-2"
                        onClick={() => {
                            navigate("/feedback");
                            onClose();
                        }}
                    >
                        <div className="text-h2 sline fcap hover-u ">feedback</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
